import { useState } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FiltersDrawer } from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';
import IconCross from '@/icons/Cross.svg';
import { useBrands } from '@/models/brand';
import { useSettingsScope } from '@/routes/SettingsBeta/SettingsContext';

import { useFilters } from '../FiltersState';

import { FiltersBrand } from './FiltersBrand';

export const MobileFilters = () => {
  const { t } = useLingui();
  const [isOpen, setIsOpen] = useState(false);
  const { scope } = useSettingsScope();
  const organizationId = scope?.scope === 'organization' ? scope.organizationId : undefined;

  const { search, activeFiltersCount, clearFilters } = useFilters();

  const { data: brandsData } = useBrands({
    organizationId,
    limit: 500,
    offset: 0,
  });

  const showBrandFilter = !!brandsData?.brands && brandsData.brands.length > 1;

  return (
    <Stack gap="0.75rem">
      <Stack row gap="1rem" alignItems="center">
        <InputSearch
          ariaLabel={t({
            id: 'settings.organization.data-catalogs.products.search.label',
            message: 'Search products',
          })}
          placeholder={t({
            id: 'settings.organization.data-catalogs.products.search.placeholder',
            message: 'Search products...',
          })}
          value={search.search}
          onChange={search.debouncedSetSearch}
          style={{ flex: 1 }}
        />
        {showBrandFilter ? (
          <FiltersDrawer
            button={<FiltersButton count={activeFiltersCount} onClick={() => setIsOpen(true)} />}
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            onClearFilters={activeFiltersCount ? clearFilters : undefined}
          >
            <FiltersBrand />
          </FiltersDrawer>
        ) : null}
      </Stack>

      {activeFiltersCount > 0 && (
        <Stack row gap="1rem" justifyContent="flex-end" alignItems="center">
          <Button
            variant="link-subtle"
            onPress={clearFilters}
            style={{ textWrap: 'nowrap' }}
            size="small"
          >
            <IconCross />
            <Trans id="settings.organization.data-catalogs.products.filters.clear_all">
              Clear filters
            </Trans>
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
